import { GrowthBook } from "@growthbook/growthbook";
import { autoAttributesPlugin } from "@growthbook/growthbook/plugins";
import { v4 as uuidv4 } from 'uuid';
import { markRaw } from 'vue';
import {logEvent} from "@/tarot_box/helper/native_api";

// 개발 환경 여부
const isDev =
    process.env.NODE_ENV === 'development' ||
    window.location.hostname === 'localhost';

// localStorage 키
const GROWTHBOOK_ID_KEY = 'growthbook_ephemeral_id';
const GROWTHBOOK_APP_ID_KEY = 'growthbook_app_id';

// 영속 ID 생성 및 저장
function getPersistentId(key) {
    let id = localStorage.getItem(key);
    if (!id) {
        id = uuidv4();
        localStorage.setItem(key, id);
    }
    return id;
}

// Vue 반응성에서 제외할 GrowthBook 인스턴스 생성
export const gbKey = Symbol('growthbook');

export const initGrowthBook = async () => {
    // URL 파라미터 읽기
    const params = new URLSearchParams(window.location.search);
    const tarotUserId = params.get('tarot_user_id');
    const isWebSession = params.get('is_web') === 'true';

    // 사용자 속성 정의
    const attrs = {
        id: tarotUserId
            ? tarotUserId
            : isWebSession
                ? getPersistentId(GROWTHBOOK_ID_KEY)
                : getPersistentId(GROWTHBOOK_APP_ID_KEY),
        deviceType: 'mobile',
        appVersion: '1.0',
        loggedIn: !!tarotUserId,
        environment: isDev ? 'development' : 'production',
        isWeb: isWebSession,
    };

    // GrowthBook 인스턴스 초기화
    const growthbook = markRaw(
        new GrowthBook({
            apiHost: 'https://cdn.growthbook.io',
            clientKey: 'sdk-QdjXaei7vJTfIjZU',
            enableDevMode: isDev,
            subscribeToChanges: true,
            attributes: attrs,
            trackingCallback: (experiment, result) => {
                console.log('Viewed Experiment', {
                    experimentId: experiment.key,
                    variationId: result.key,
                });
                logEvent('experiment_viewed',{
                    experimentId: experiment.key,
                    variationId: result.key,
                })
            },
            plugins: [autoAttributesPlugin()],
        })
    );

    try {
        // 피처 플래그 로드
        await growthbook.loadFeatures();
    } catch (e) {
        console.error('GrowthBook loadFeatures 오류:', e);
    }

    return growthbook;
};

export default initGrowthBook;
